import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import style from './Allusers.module.css';

import AdminNavBar from "../../NavBar/AdminNavBar";
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";

export default function AllUsers() {

    const [users, setUsers] = useState([]);
    const [error, setError] = useState('');
    const [roleFilter, setRoleFilter] = useState("All");
    const [positionFilter, setPositionFilter] = useState("All");
    const [loading, setLoading] = useState(true)
    const [currentPage, setCurrentPage] = useState(1);
    const usersPerPage = 10;

    const token = localStorage.getItem("token");
    const { employeeId: adminId } = useParams();
    const apiUrl = process.env.REACT_APP_SERVER_URL;

    // filter users based on role and position
    const filteredUsers = users.filter((user) => {
        return (
            (roleFilter === "All" || user.role === roleFilter) &&
            (positionFilter === "All" || user.position === positionFilter)
        );
    });

    // Pagination logic
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
    const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

    // Pagination Handle Next
    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
    };

    // Pagination Handle Previous
    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    };

    // Fetch all users
    useEffect(() => {
        if (!apiUrl) {
            setError("API is not working");
            return;
        }
        fetch(`${apiUrl}/users`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            }
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false)
                setUsers(data.users)
            })
            .catch(err => {
                setError(err.message)
                setLoading(true)
            });
    }, [apiUrl, token, roleFilter, positionFilter]);

    return (
        <div className="container pb-lg-5 mb-5">
            <div className={style.usersPage}>
                <AdminNavBar />
                <div className="row pt-lg-4 mb-3">

                    {/* BreadCrumb Linkss */}
                    <div className="col-8 col-lg-5 ">
                        <BreadCrumb
                            link={`/admin-dashboard/${adminId}`}
                            name="Dashboard"
                            icon={true}
                        />
                        <BreadCrumb
                            link={`/admin-dashboard/${adminId}/all-users`}
                            name="All Users"
                        />
                    </div>

                    {/* total employee length */}
                    <div className="col-2 d-md-none d-lg-none d-xl-none d-xxl-none">
                        <p className={`${style.breadcrumb} pt-2`}>Employees:<b>{filteredUsers.length}</b></p>
                    </div>

                    {/* dummy component for ui purpose */}
                    <div className="col-lg-1"></div>

                    {/* select option for role list */}
                    <div className="col-6 col-lg-2 ">
                        <select
                            className="form-select"
                            value={roleFilter}
                            onChange={(e) => setRoleFilter(e.target.value)}
                        >

                            <option value="All">Select Role (All)</option>
                            <option value="Admin">Admin</option>
                            <option value="HR">HR</option>
                            <option value="Employee">Employee</option>
                            <option value="Manager">Manager</option>
                        </select>
                    </div>

                    {/* position filter */}
                    <div className="col-6 col-lg-2">
                        <select
                            className="form-select"
                            value={positionFilter}
                            onChange={(e) => setPositionFilter(e.target.value)}
                        >
                            <option value="All">Select Position (All)</option>
                            <option value="Head Admin">Head Admin</option>
                            <option value="Junior Admin">Junior Admin</option>
                            <option value="Head Manager">Head Manager</option>
                            <option value="Hr">Hr</option>
                            <option value="Front End Developer">Front End Developer</option>
                            <option value="UI Designer">UI Designer</option>
                            <option value="React Developer">React Developer</option>
                            <option value="NodeJS Developer">NodeJS Developer</option>
                            <option value="MERN Developer">MERN Developer</option>
                            <option value="MEAN Developer">MEAN Developer</option>
                            <option value="Database Developer">Database Developer</option>
                            <option value="Manual Tester">Manual Tester</option>
                            <option value="Automation Tester">Automation Tester</option>
                        </select>
                    </div>

                    {/* total employee length */}
                    <div className="col-lg-2 pe-5  d-none d-sm-none d-lg-block">
                        <p className={`${style.link} pt-1`}>Employees: <b>{filteredUsers.length}</b></p>
                    </div>
                </div>

                {/* error component */}
                {error && <p className="text-danger">{error}</p>}

                {/* table for fetch the user data */}
                <div className="table-responsive">
                    <table className="table table-striped table-bordered table-responsive placeholder-glow">
                        <thead>
                            <tr>
                                <th className="text-center">Employee Id</th>
                                <th className="text-center">Name</th>
                                <th className="text-center">Email</th>
                                <th className="text-center">Role</th>
                                <th className="text-center">Position</th>
                                <th className="text-center">Team</th>
                                <th className="text-center">Phone</th>
                                <th className="text-center">Info</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                loading ?
                                    <>
                                        {Array.from({ length: 10 }).map((_, idx) => {
                                            return (
                                                <>
                                                    <tr key={idx} >
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                    </tr>
                                                </>
                                            )
                                        })}
                                    </>
                                    :
                                    <>
                                        {currentUsers.map((user) => (
                                            <tr key={user._id}>
                                                <td className="text-center">{user.employeeId}</td>
                                                <td className="text-center text-capitalize">{user.firstName} {user.lastName}</td>
                                                <td className="text-center">{user.email}</td>
                                                <td className="text-center">{user.role}</td>
                                                <td className="text-center">{user.position}</td>
                                                <td className="text-center">{user.teamName}</td>
                                                <td className="text-center">{user.phonePrimary}</td>
                                                <td className="text-center">
                                                    <Link to={`/admin-dashboard/${adminId}/users/${user.employeeId}`}>Info</Link>
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                            }

                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="row pt-4">
                    <div className="col-12 text-center ">
                        <button style={{ border: 'none' }}
                            className=" mx-2"
                            onClick={handlePrev}
                            disabled={currentPage === 1}
                        >
                            <b>{"<<"}</b>
                        </button>
                        <span className="mx-2">
                            Page {currentPage} of {totalPages}
                        </span>
                        <button style={{ border: 'none' }}
                            className=" mx-2"
                            onClick={handleNext}
                            disabled={currentPage === totalPages}
                        >
                            <b>{">>"}</b>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
}
